import styled, { keyframes } from 'styled-components';
import IconWrapperImage from '../../Images/Icons/IconWrapper.png';

export const Root = styled.div`
 width:115px;
 min-width:115px;
 position:sticky;
 top:0;
 left:0;
 height:100vh;
 max-height:100vh;
 background-color:${(p) => p.theme.colors.leftSidebarbg};
 display:flex;
 flex-direction:column;
 justify-content:space-between;
 overflow-y:scroll;
 ::-webkit-scrollbar{
    width:4px;
    height:3px;
 }
 ::-webkit-scrollbar-thumb{
  background-color:${(p) => p.theme.colors.darkvioletColor};
  border-radius:4px;
}
@media(max-width:${(p) => p.theme.screen.sm}){
  display:none;
}

@media(min-width:1600px){
  width:135px;
  min-width:135px;
}
@media(min-width:1700px){
  width:155px;
  min-width:155px;
}
`;

export const IconWrapper = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
 
  ${(p) => p.top && `
   margin-top:${(p.theme.spacing[p.top])};
   @media(max-width:${p.theme.screen.sm}){
    margin-top:${p.theme.spacing.none};
  }
 `};
 ${(p) => p.bottom && `
   margin-bottom:${(p.theme.spacing[p.bottom])};
   @media(max-width:${p.theme.screen.sm}){
    margin-bottom:${p.theme.spacing.none};
  }
`};
cursor:pointer;

`;

export const LogoWrapper = styled.div`
display:flex;
justify-content:center;
`;
export const IconCard = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  flex-direction:column;
  margin-bottom:${(p) => p.theme.spacing.sm};
  ${(p) => p.selected && `
  background-color:${p.theme.colors.darkvioletColor};
  padding:${p.theme.spacing.sm} 0;
  `};

`;

export const Icon = styled.img`
 ${(p) => p.width && `
    width:${p.width};
 `};
 ${(p) => p.height && `
    height:${p.height};
 `};
${(p) => p.top && `
   margin-top:${(p.theme.spacing[p.top])};
`};
${(p) => p.bottom && `
   margin-bottom:${(p.theme.spacing[p.bottom])};
`};
@media(max-width:${(p) => p.theme.screen.sm}){
  width:24px;
  height:fit-content;
}
@media(min-width:1600px){
   width:32px !important;
   block-size: fit-content;
   height:fit-content !important;
}

`;

export const Logo = styled.img`
${(p) => p.width && `
    width:${p.width};
 `};
 ${(p) => p.height && `
    height:${p.height};
 `};
${(p) => p.top && `
   margin-top:${(p.theme.spacing[p.top])};
`};
${(p) => p.bottom && `
   margin-bottom:${(p.theme.spacing[p.bottom])};
`};
@media(max-width:${(p) => p.theme.screen.sm}){
  width:60px;
  height:fit-content;
}
`;

export const Text = styled.div`
font-size:${(p) => p.theme.font.size.tiny};
margin-top:${(p) => p.theme.spacing.xs};

@media(min-width:1600px){
    font-size:${(p) => p.theme.font.size.sm};
}
`;
const mymove =keyframes`
from {
  width: 0;
}
to {
  width: 300px;
}
`;
export const MobileView = styled.div`
display:none;
@media(max-width:${(p) => p.theme.screen.sm}){
  display:flex;
  background-color:${(p) => p.theme.colors.cardBgColor};
  height:100vh;
  width:300px;
  min-width:300px;
  position:fixed;
  top:0;
  z-index:100;
  flex-direction:column;
  justify-content:left;
  animation-name: ${mymove};
  animation-duration: 0.9s;
}
/* @media(max-width:${(p) => p.theme.screen.xs}){
  width:250px;
  min-width:250px;
} */
`;

export const MenuIconWrapper = styled.div`
position:absolute;
left:10px;
top:10px;
font-size:20px;
z-index: 10;
color:${(p) =>p.theme.colors.white};
cursor:pointer;
display: none;
@media(max-width:${(p) => p.theme.screen.sm}){
  top:30px;
  left:15px;
  display: flex;
}
`;

export const MobileIconWrapper = styled.div`
display:flex;
cursor:pointer;
padding:${(p) => p.theme.spacing.sm};
${(p) => p.selected && `
   background-color:${ p.theme.colors.darkSectionbg};
`};

:hover{
  background-color:${(p) => p.theme.colors.darkSectionbg};
}
`;

export const MobileLogoWrapper = styled.div`
display:flex;
align-items:center;
justify-content:left;
padding-left:20px;
cursor:pointer;
`;

export const TextWraper = styled.div`
font-size:${(p) => p.theme.font.size.sm};
margin-left:${(p) =>p.theme.spacing.sm};
`;

export const MobileIcon = styled.img`


`;

export const CloseIconWrapper = styled.div`
  font-size:20px;
  position:absolute;
  top:20px;
  right:20px;
  cursor:pointer;
`;


export const ProfileIcon = styled.div`
font-size: 24px;
`;